import { UpdateReview } from '../../../components/Admin/Reviews';

const UpdateScreen = () => (
    <div className="articles__edit">
        <UpdateReview />
    </div>
);

export default UpdateScreen;
